const validators = {     
    password: {
        length: {
          minimum: 6,
          message: "^errors.register.password_to_short"
        }
    },
    repeat_password: {
      equality: {
        attribute: "password",
        message: "^errors.update_user_details.passwords_not_matching"
      }    
    }
};
  
  export default validators;
  